import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import React, { useContext, useMemo } from 'react';
import { C, H } from '../Layout';
import { BUTTON_VARIANTS, PUNCTUATION_MARKS_CONSTANTS } from '../constants/constants';
import I18n from '../i18n/I18n';
import { getActionButtons } from '../utils/commonUtils';
import { FormContext } from './FormContext';
import { FormModalFooterProps } from './formUtils';

const reqStyles = {
    width: '100%',
    justifyContent: 'space-between'
};

export default function FormModalFooter({
    additionalLeftsideActions,
    additionalActions,
    hideDefaultButtons,
    isReqFields,
    isSaveDisabled,
    isSaving,
    loadingButtonVariant,
    onSave,
    saveLabel,
    hideFooter
}: FormModalFooterProps) {
    const { validation } = useContext(FormContext);

    const leftActions = useMemo(() => getActionButtons(additionalLeftsideActions, 'form'), [additionalLeftsideActions]);
    const actions = useMemo(
        () => (additionalActions.length && getActionButtons(additionalActions, 'form')) || [],
        [additionalActions]
    );

    return (
        <C
            sx={{
                display: 'flex',
                borderTop: 1,
                borderColor: 'divider',
                p: 2,
                ...(leftActions
                    ? { justifyContent: 'space-between' }
                    : { alignSelf: 'flex-end', alignItems: 'flex-end' })
            }}
            hide={hideFooter}
        >
            <C hide={!leftActions.length} className="form-modal-buttons">
                {leftActions}
            </C>
            <H
                className="form-modal-buttons"
                sx={isReqFields ? { ...reqStyles } : { flexDirection: 'row', justifyContent: 'end' }}
                gap={1}
            >
                {isReqFields && (
                    <Typography sx={{ display: 'flex', color: 'required.main' }}>
                        <Typography>{PUNCTUATION_MARKS_CONSTANTS.asterisk}</Typography>
                        <I18n token="modal.required.fields.missing" />
                    </Typography>
                )}
                <C sx={{ display: 'flex', flexDirection: 'row' }} gap={1}>
                    {actions}
                    {!hideDefaultButtons && (
                        <LoadingButton
                            variant={loadingButtonVariant || BUTTON_VARIANTS.text}
                            loading={isSaving}
                            disabled={isSaveDisabled || (validation ? !validation.isValid : false)}
                            onClick={onSave}
                        >
                            {saveLabel}
                        </LoadingButton>
                    )}
                </C>
            </H>
        </C>
    );
}
